export default {
  all: state => {
    return state.all
  },
  single: state => {
    return state.single
  },
  publishers: state => {
    return state.publishers
  },
  termLabels: state => {
    return state.termLabels
  },
  termStatuses: state => {
    return state.termStatuses
  },
  owners: state => {
    return state.owners
  }
}
